var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"spinners",class:_vm.size},[_c('svg',{attrs:{"width":"1em","height":"1em"}},[_c('circle',{attrs:{"cx":"0.5em","cy":"0.5em","r":"0.45em"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }